import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import boot from './utils/boot';
import BemobAPI from './rest/bemob';

@Component
export class Api extends mixins<BemobAPI>(BemobAPI) {
  /*
  * Add promises for fetching initial data from the api
  * */
  bootstrap: any[] = [this.waitVueReady];

  created() {
    boot(this.bootstrap)
      .then(() => {})
      .catch(() => {});
  }

  waitVueReady() {
    return new Promise((resolve, reject) => {
      this.$nextTick(() => {
        setTimeout(resolve, 300);
      });
    });
  }
}

export default new Api();
